module.exports = __webpack_public_path__ + "static/media/cibraIcon.8c77be83.svg";